export const profileMorningMonitoring = {
    namespaced: true,

    state: {
        dateModel: {
            startDate: null,
            endDate: null
        }
    },

    getters: {
        getStartDateModel(state) {
            return state.dateModel.startDate;
        },

        getEndDateModel(state) {
            return state.dateModel.endDate;
        }
    },

    actions: {
        setStartDate(context, payload) {
            Vue.set(context.state.dateModel, 'startDate', payload);
        },

        setEndDate(context, payload) {
            Vue.set(context.state.dateModel, 'endDate', payload);
        }
    }
};
